import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import { Alphabet } from "design-system/resources/html/components/glossary/alphabet/alphabet";
import Guides from "design-system/resources/html/components/common/guides/guides";
import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";
// import LivePricesContract from "design-system/resources/html/components/contract-specifications/live-prices-contract/live-prices-contract";
// import MarginCalculator from "design-system/resources/html/components/margin-calculator/margin-calculator";
import Registartion from "design-system/resources/html/components/common/registration/registration";
import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";
import Table from "design-system/resources/html/components/platforms/table/table";
import CompareAccounts from "design-system/resources/html/components/account-overview/compare-accounts/compare-accounts";
import Tabs from "design-system/resources/html/components/faq/tabs/tabs";
import DepositsTabs from "design-system/resources/html/components/deposits/deposits-tabs/deposits-tabs";
//import CarouselAutoSlide from "design-system/resources/assets/js/carouselAutoSlide";
import SideBarMenuStikcy from "design-system/resources/html/components/common/sidebar/sidebar";

import PhotoGalleryCarousel from "design-system/resources/html/components/photo-gallery-carousel/photo-gallery-carousel";
import { BackToTop } from "design-system/resources/html/components/glossary/back-to-top/back-to-top";
import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import WebinarDetailJumbotron from "design-system/resources/html/components/webinar-detail/jumbotron/jumbotron";
import CardScroll from "design-system/resources/html/components/common/card-list/card-scroll";

import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForGlideSlide from './glide';
import addItemSessionStorage from "./addItemSessionStorage";
import mParticleLogEvent from "./mParticleLogEvent";
import ibFormHelperFunc from "./ib-form";

const tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
tooltipTriggerList.forEach(function (tooltipTriggerEl) {
  new Tooltip(tooltipTriggerEl);
});

window.onload = function () {
  getIdCarouselForAutoSlide();
  Guides();
  BackToTop();
  Tabs();
  Alphabet();
  ResponsiveTable();
  // LivePricesContract();
  // MarginCalculator();
  Registartion();
  Header();
  NavbarMobile();
  Table();
  CompareAccounts();
  DepositsTabs();
  PhotoGalleryCarousel();
  RiskWarningBar();
  CardScroll();
  WebinarDetailJumbotron();
  getIdCarouselForGlideSlide();
  SideBarMenuStikcy();
  mParticleLogEvent();
  addItemSessionStorage();
};

(function (Drupal) {
  Drupal.behaviors.ib_form = {
    attach: function(context, settings) {

      if((window.location.href.indexOf("#swap") != -1)
        && document.getElementById("pills-tab")) {
        let second_tab = document.getElementById("tab-2");

        if(second_tab) {
          second_tab.click();
        }
      }
      ibFormHelperFunc();
      if (Drupal.ajax.instances && Drupal.ajax.instances.length > 0) {
        for (let [AjaxInstanceIndex, AjaxInstance]  of Drupal.ajax.instances.entries()) {

          if (Drupal.ajax.instances[AjaxInstanceIndex] && AjaxInstance.options.url.includes("/ib") && AjaxInstance.options.url.includes("ajax_form=1&_wrapper_format")
            && (window.location.host.includes("forextime.com") || window.location.host.includes("staging.fxtm"))
            && !window.location.pathname.includes("zh-")
            && !AjaxInstance.options.url.includes("/zh")
          ) {
            Drupal.ajax.instances[AjaxInstanceIndex].options.url = "/zh" + AjaxInstance.options.url;
          }
        }
      }
    }
  };
})(Drupal);